import before_i_go_to_sleep from './img/before_i_go_to_sleep.jpg'
import gone_girl from './img/gone_girl.jpg'
import my_sister_the_serial_killer from './img/my_sister_the_serial_killer.jpg'
import the_da_vinci_code from './img/the_da_vinci_code.jpg'
import the_girl_on_the_train from './img/the_girl_on_the_train.jpg'
import then_she_was_gone from './img/then_she_was_gone.jpg'
import the_girl_who_kicked_the_hornet_nest from './img/the_girl_who_kicked_the_hornet_nest.jpg'
import the_lost_symbol from './img/the_lost_symbol.jpg'
import the_girl_with_the_dragon_tattoo from './img/the_girl_with_the_dragon_tattoo.jpg'
import anatomy_of_A_murder from './img/anatomy_of_A_murder.jpg'
import and_then_there_were_none from './img/and_then_there_were_none.webp'
import dragon_tattoo from './img/dragon_tattoo.jpg'
import murder_on_the_orient_express from './img/murder_on_the_orient_express.jpg'
import tana_french from './img/tana_french.jpg'
import rebecca from './img/rebecca.jpg'
import the_big_sleep from './img/the_big_sleep.jpg'
import the_wife_between_us from './img/the_wife_between_us.jpg'
import the_maid from './img/the_maid.jpg'
import tinker_tailor from './img/tinker_tailor.jpg'
import the_woman_in_white from './img/the_woman_in_white.jpg'
import MBookItem from './MBookItem'


export const MBookItems = [
  {
    id:101,
    title:"The Da Vinci Code",
    image: the_da_vinci_code,
    price:259,
    
  },
  {
    id:102,
    title:"Anatomy Of A Murder",
    image: anatomy_of_A_murder,
    price:1488,
    
  },
  {
    id:103,
    title:"Rebecca",
    image: rebecca,
    price:330,
    
  },
  {
    id:104,
    title:"Tinker Tailor",
    image: tinker_tailor,
    price:229,
    
  },
  {
    id:105,
    title:"The Big sleep",
    image: the_big_sleep,
    price:499,
    
  },
  {
    id:106,
    title:"The Wife Between us",
    image: the_wife_between_us,
    price:1129,
    
  },
  {
    id:107,
    title:"The Maid",
    image: the_maid,
    price:1849,
    
  },
  {
    id:108,
    title:"The Woman in White",
    image: the_woman_in_white,
    price:359,
    
  },
  {
    id:109,
    title:"And Then There Were None",
    image: and_then_there_were_none,
    price:1149,
    
  },
  {
    id:110,
    title:"Dragon Tattoo",
    image: dragon_tattoo,
    price:899,
    
  },
  {
    id:111,
    title:"Murder On The Orient Express",
    image: murder_on_the_orient_express,
    price:219,
    
  },
  {
    id:112,
    title:"Tana French",
    image: tana_french,
    price:709,
    
  },
  {
    id:113,
    price:178,
    title: "Gone Girl",
    image: gone_girl,
    
  },
  {
    id:114,
    price:3848,
    title: "My Sister The Serial Kille",
    image: my_sister_the_serial_killer,
   
  },
  {id:115,
    price:279,
    title: "Before I Go To Sleep",
    image: before_i_go_to_sleep,
    
  },
  {
    id:116,
    price:259,
    title: "The Girl On The Train",
    image: the_girl_on_the_train,
    
  },
  {
    id:117,
    price:459,
    title: "Then She Was Gone",
    image: then_she_was_gone,
    
  },
  {
    id:118,
    price:1250,
    title: "The Girl Who Kicked The Hornet Nest",
    image: the_girl_who_kicked_the_hornet_nest,
    
  },
  {
    id:119,
    price:499,
    title: "The Lost Symbol",
    image: the_lost_symbol,
    
  },
  {
    id:120,
    price:1422,
    title: "The Girl With The Dragon Tattoo",
    image: the_girl_with_the_dragon_tattoo,
    
  },
  
];
